export const en = {
    common: {
        loading: 'Loading...',
        error: 'Something went wrong',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        download: 'Download',
        upload: 'Upload',
        back: 'Back',
        noResults: 'No results',
    },
    nav: {
        dashboard: 'Dashboard',
        projects: 'Projects',
        settings: 'Settings',
        admin: 'Admin',
        clients: 'Clients',
        leads: 'Leads',
        files: 'Files',
        logout: 'Log out',
    },
    dashboard: {
        title: 'Dashboard',
        welcome: 'Welcome, {name}',
        yourProjects: 'Your Projects',
        noProjects: 'No projects yet. Your consultant will set up your workspace.',
        diagnosticBanner: 'You completed the AI Production Readiness Diagnostic on {date}.',
        viewResults: 'View Results',
    },
    projects: {
        title: 'Projects',
        deliverables: 'Deliverables',
        noDeliverables: 'No deliverables uploaded yet.',
        uploaded: 'Uploaded {date}',
        version: 'v{version}',
    },
    access: {
        title: 'Request Access',
        subtitle: 'Your email is verified, but you don\'t have a portal account yet.',
        name: 'Your name',
        company: 'Company',
        interest: 'How can we help? (optional)',
        submit: 'Request Access',
        submitted: 'Request submitted. We\'ll be in touch.',
    },
    admin: {
        clients: 'Clients',
        newOrg: 'New Organisation',
        inviteUser: 'Invite User',
        leads: 'Diagnostic Leads',
        uploadFile: 'Upload File',
        newProject: 'New Project',
    },
    gdpr: {
        exportData: 'Export My Data',
        deleteAccount: 'Delete My Account',
        deleteConfirm: 'This action cannot be undone. Your account will be deactivated immediately and data permanently deleted within 30 days.',
    },
    scanner: {
        campaigns: 'Campaigns',
        newCampaign: 'New Campaign',
        campaignName: 'Campaign name',
        campaignNamePl: 'Campaign name (Polish)',
        organisation: 'Organisation',
        deadline: 'Survey deadline',
        inviteMessage: 'Invite email message',
        status: 'Status',
        responses: 'Responses',
        invites: 'Invites',
        tools: 'Discovered Tools',
        draft: 'Draft',
        active: 'Active',
        closed: 'Closed',
        archived: 'Archived',
        sendInvites: 'Send Invites',
        addEmails: 'Add email addresses (one per line)',
        analyse: 'Analyse Responses',
        downloadReport: 'Download Report',
        riskLevel: 'Risk Level',
        dataSensitivity: 'Data Sensitivity',
        businessCriticality: 'Business Criticality',
        department: 'Department',
        useCase: 'Use Case',
        noResponses: 'No responses yet. Send invites to start collecting data.',
        noCampaigns: 'No campaigns yet. Create one to start scanning.',
        activate: 'Activate Campaign',
        closeCampaign: 'Close Campaign',
        template: 'Survey Template',
        surveyTitle: 'AI Tool Usage Survey',
        surveySubtitle: 'This survey is anonymous and takes approximately 3 minutes.',
        surveySubmitted: 'Thank you! Your response has been recorded.',
        surveyExpired: 'This survey has closed.',
        next: 'Next',
        submit: 'Submit',
        previous: 'Previous',
    },
};
